import React from 'react'

import {
    Meme, Share, Notification, Bigscreen
} from "./Section3Elements"

import "./section3.css"

import meme from "../../../assets/images/meme.svg"
import share from "../../../assets/images/share.svg"
import notification from "../../../assets/images/notification.svg"
import bigscreen from "../../../assets/images/bigscreen.svg"

const Section3 = () => {
    return (
        <section className="section3">
            {/* create pipes */}
            <div className="create--pipes">
                <div className="pipe--content">
                    <h1>
                        Create Pipes: Save anything in the most organized way possible 😎
                    </h1>
                    <p>
                        Create pipes and share your favorite
                        contents from any platfrom directly
                        into them. Avoid endless scrolling
                        and browse through them quickly and easily!
                    </p>
                </div>
                <div>
                    <Meme src={meme} alt="meme, threads, clips svg" />
                </div>
            </div>
            {/* share pipes */}
            <div className="share--pipes">
                <div>
                    <Share src={share} alt="share illustration" />
                </div>
                <div className="pipe--content">
                    <h1>
                        Like music playlists,
                        curate & share pipes with anyone🚀
                    </h1>
                    <p>
                        You can share pipes containing
                        some of your most interesting
                        and insigtful contents with
                        just anyone. Publicly with a
                        link or privately with their
                        usernames.
                    </p>
                </div>
            </div>
            {/* pipe rewind */}
            <div className="pipe--rewind">
                <div className="pipe--content">
                    <div className="comingsoon">
                        <p className="comingsoon--text">
                            Coming soon ⚡️
                        </p>
                    </div>
                    <h1>
                        Pipe Rewind: Weekly review of
                        all new saved content 🔔
                    </h1>
                    <p>
                        Every week, you get a summary of
                        pipes you created, pipes you
                        shared and added, and the
                        contents you added to your pipes.
                    </p>
                </div>
                <div>
                    <Notification src={notification} alt="notification illustration" />
                </div>
            </div>
            <div className="pipe--extension">
                <div>
                    <Bigscreen src={bigscreen} alt="notification illustration" />
                </div>
                <div className="pipe--content">
                    <div className="comingsoon">
                        <p className="comingsoon--text">
                            Coming soon ⚡️
                        </p>
                    </div>
                    <h1>
                        Web extension: get plugged everywhere🔥
                    </h1>
                    <p>
                        Install the browser plugin and have
                        your most interesting content saved
                        and get it synced both on web and on
                        the app.
                    </p>
                </div>
            </div>
        </section>
    )
}

export default Section3
